import { createDataset } from 'chem-generic-ui';
import Element from 'src/models/Element';

// Create GenericDS class
const GenericDS = createDataset(Element);

export default GenericDS;
